// Query param used by RedirectPage / login flow to remember the path the user originally requested.
export const LOGIN_REDIRECT_PARAM = 'redirect';
